/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Template_CondensedInputs */

const en_ccsl_export_template_condensed = /** @type {(inputs: Ccsl_Export_Template_CondensedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Condensed`)
};

const fr_ccsl_export_template_condensed = /** @type {(inputs: Ccsl_Export_Template_CondensedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Condense`)
};

const de_ccsl_export_template_condensed = /** @type {(inputs: Ccsl_Export_Template_CondensedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kondensiert`)
};

const it_ccsl_export_template_condensed = /** @type {(inputs: Ccsl_Export_Template_CondensedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Condensato`)
};

const ru_ccsl_export_template_condensed = /** @type {(inputs: Ccsl_Export_Template_CondensedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сокращенный`)
};

const es_ccsl_export_template_condensed = /** @type {(inputs: Ccsl_Export_Template_CondensedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Condensado`)
};

const zh_cn2_ccsl_export_template_condensed = /** @type {(inputs: Ccsl_Export_Template_CondensedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`浓缩版`)
};

const ja_ccsl_export_template_condensed = /** @type {(inputs: Ccsl_Export_Template_CondensedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`要約`)
};

const hi_ccsl_export_template_condensed = /** @type {(inputs: Ccsl_Export_Template_CondensedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संघनित`)
};

const pt_pt2_ccsl_export_template_condensed = /** @type {(inputs: Ccsl_Export_Template_CondensedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Condensado`)
};

/**
* | output |
* | --- |
* | "Condensed" |
*
* @param {Ccsl_Export_Template_CondensedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_template_condensed = /** @type {((inputs?: Ccsl_Export_Template_CondensedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Template_CondensedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_template_condensed(inputs)
	if (locale === "de") return de_ccsl_export_template_condensed(inputs)
	if (locale === "it") return it_ccsl_export_template_condensed(inputs)
	if (locale === "ru") return ru_ccsl_export_template_condensed(inputs)
	if (locale === "es") return es_ccsl_export_template_condensed(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_template_condensed(inputs)
	if (locale === "ja") return ja_ccsl_export_template_condensed(inputs)
	if (locale === "hi") return hi_ccsl_export_template_condensed(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_template_condensed(inputs)
	return en_ccsl_export_template_condensed(inputs)
});